/**
 * @file ログイン用のutility関数群
 */

import axios from 'axios'

export default {
  // 認証基盤ログインコールバック処理
  async myPageLogin(code, url) {
    return await axios.post('users/mypage_login', {
      code: code,
      redirect_uri: window.location.protocol + '//' + window.location.host + '/ninal/mypage/login/callback',
    })
  },

  // API:01
  async myPageLoginOld(id, password) {
    return await axios.post('users/old_mypage_login', {
      tanaka_id: id,
      password: password,
    })
  },

  // API:02
  async myPageLogout() {
    return await axios.delete('users/mypage_logout')
  },
  /* 規約の同意と登録 */
  async agreeAndRegister() {
    return await axios.post('users/agree')
  },
}
